import { render, staticRenderFns } from "./OrgSearch.vue?vue&type=template&id=34bd7b74"
import script from "./OrgSearch.vue?vue&type=script&lang=js"
export * from "./OrgSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports